import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { expensePolicyDetailInitialsForAdd, expensePolicyDetailInitialsForUpdate } from './interfaces/expensePolicyDetailClass';
import { UpdateAccountExpensePolicyCategorybyCategoryAsync, GetDataByAccountExpensePolicyIdAsync, UpdateAccountExpensePolicyGeneralLimitAsync, resetSelectedRecordObjectInState } from './expensePolicyDetailSlice';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { Value } from 'sass';
import { Link, useLocation } from 'react-router-dom';
import { determineCommaSeprater, FormatInvoiceDecimalNumber, formatNumberCustomoriginalapiv2, getValueFromResource, parseLocalizedNumber } from '../../../common/timeLiveFunction';
const ExpensePolicyCategoryForm = (props: any) => {
    const { modelRef, t, oncloseModal, CategorymodelRef } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expensePolicyDetailInitialsForAdd);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.expensePolicyDetail);
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { MasterExpensePolicyId } = useAppSelector((state) => state.expensePolicy);    
    const { cultureInfoName, decimalFormat, decimalPlaces } = useAppSelector((state) => state.globalState);
    const { obj } = location.state || {};   
    let AccountExpensePolicyId = '00000000-0000-0000-0000-000000000000';
     if (MasterExpensePolicyId && MasterExpensePolicyId !== '') {
        AccountExpensePolicyId = MasterExpensePolicyId;
     } else if (obj && obj.AccountExpensePolicyId) {
        AccountExpensePolicyId = obj.AccountExpensePolicyId;
     }
    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(expensePolicyDetailInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })

            stateItem.PolicyDescriptionRequired = stateItem.PolicyDescriptionRequired === true ? true : false;
            stateItem.IsDescriptionRequired = stateItem.IsDescriptionRequired === true ? true : false;
            stateItem.IsOverride = stateItem.IsOverride === true ? true : false;
            stateItem.IsDisabledCategory = stateItem.IsDisabledCategory ? (stateItem.IsDisabledCategory === true ? true : false) : false;
            stateItem.ExpenseAmountLimit = formatNumberCustomoriginalapiv2(cultureInfoName.toString(),stateItem.ExpenseAmountLimit, decimalPlaces);
            stateItem.ReceiptRequiredLimit = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), stateItem.ReceiptRequiredLimit, decimalPlaces);

            setCurrentFieldsData(stateItem);
        }

    }, [selectedRecord])
    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }

    const handleSubmit = (values: any) => {
          const formattedValues = {
                                                ...values,
                                                ExpenseAmountLimit: parseLocalizedNumber(values.ExpenseAmountLimit),
                                                ReceiptRequiredLimit: parseLocalizedNumber(values.ReceiptRequiredLimit)
                                            }
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(UpdateAccountExpensePolicyCategorybyCategoryAsync(formattedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Expense Category Limits Update Successfully", 'Success', "success", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    console.log('handleSubmitCategory-UpdateAccountExpensePolicyCategorybyCategoryAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                })
        }
       oncloseModal();
    }
    
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }


    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    ExpenseAmountLimit: yup
                        .string()
                        .label(getValueFromResource('ExpenseAmountLimit', dispatch, t))
                        .trim()
                        .required(getValueFromResource('Expense Amount Limit is required', dispatch, t))
                        .test(
                            'culture-format-check',
                            () => {
                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                return isComma
                                    ? "Only numbers and comma (,) are allowed."
                                    : "Only numbers and dot (.) allowed";
                            },
                            (value) => {
                                if (!value) return true;
                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                if (isComma) {
                                    return /^\d+(,\d+)?$/.test(value);
                                } else {
                                    return /^\d+(\.\d+)?$/.test(value);
                                }
                            }
                        ),
                    ReceiptRequiredLimit: yup
                        .string()
                        .label(getValueFromResource('ReceiptRequiredLimit', dispatch, t))
                        .trim()
                        .required(getValueFromResource('Receipt Required Limit is required', dispatch, t))
                        .test(
                            'culture-format-check',
                            () => {
                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                return isComma
                                    ? "Only numbers and comma (,) are allowed."
                                    : "Only numbers and dot (.) allowed";
                            },
                            (value) => {
                                if (!value) return true;
                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                if (isComma) {
                                    return /^\d+(,\d+)?$/.test(value);
                                } else {
                                    return /^\d+(\.\d+)?$/.test(value);
                                }
                            }
                        )

                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">{values.AccountExpenseName}</h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal">
                                                                    {/* {t('Override General Limits')} */}
                                                                    {getValueFromResource('Override General Limits',dispatch, t)}
                                                                    </label>
                                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsOverride} id="IsOverride"
                                                                            onChange={handleChange('IsOverride')}
                                                                        />
                                                                </div>
                                                            </div>

                                                            <div className="mb-3 mt-2">
                                                                <label className="fs-7 fs-7 fw-normal mb-2 mt-2">
                                                                    {/* {t('Expense Amount Limit')} */}
                                                                    {getValueFromResource('Expense Amount Limit',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='ExpenseAmountLimit' value={values.ExpenseAmountLimit} name='ExpensePolicyName'
                                                                    onChange={handleChange('ExpenseAmountLimit')}
                                                                    onBlur={() => setFieldTouched('ExpenseAmountLimit')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('ExpenseAmountLimit', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom: 5 }}>
                                                                {touched.ExpenseAmountLimit && errors.ExpenseAmountLimit &&
                                                                    <p className='errorMsg'>{errors.ExpenseAmountLimit as string}</p>
                                                                }
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal mb-2">
                                                                    {/* {t('Receipt Required Limit')} */}
                                                                    {getValueFromResource('Receipt Required Limit',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='ReceiptRequiredLimit' value={values.ReceiptRequiredLimit} name='ExpensePolicyName'
                                                                    onChange={handleChange('ReceiptRequiredLimit')}
                                                                    onBlur={() => setFieldTouched('ReceiptRequiredLimit')}
                                                                    style={{ color: '#172b4d' }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('ReceiptRequiredLimit', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom: 5 }}>
                                                                {touched.ReceiptRequiredLimit && errors.ReceiptRequiredLimit &&
                                                                    <p className='errorMsg'>{errors.ReceiptRequiredLimit as string}</p>
                                                                }
                                                            </div>
                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                                <div className="mb-3" >
                                                                    <label className="fs-7 fw-normal">
                                                                        {/* {t('Is Description Required')} */}
                                                                        {getValueFromResource('Is Description Required',dispatch, t)}
                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDescriptionRequired} id="IsDescriptionRequired"
                                                                            onChange={handleChange('IsDescriptionRequired')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                                <div className="mb-3" >
                                                                    <label className="fs-7 fw-normal">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}
                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabledCategory} id="IsDisabledCategory"
                                                                            onChange={handleChange('IsDisabledCategory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}
                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                        {/* {t('Save')}   */}
                                                        {getValueFromResource('Save',dispatch, t)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>

        
    )
}

export default ExpensePolicyCategoryForm